import {Alert, Button, Modal} from 'antd'
import DocumentUpload from '../../../components/Project/Dashboard/DocumentUpload'
import React, {Fragment} from 'react'

function UploaderAlert(props) {
  const {VisibleTemplate, onCancelTemplate, onShowTemplate, updating} = props
  return (
    <Fragment>
      <Modal
        title="Require Document Upload"
        visible={VisibleTemplate}
        onCancel={onCancelTemplate}
        footer={false}
        width={'75%'}>
        <DocumentUpload {...props} />
      </Modal>
      <Alert
        style={{marginRight: 10, marginTop: 20}}
        message="Alert!"
        description={
          <Fragment>
            <p> Required Documents not uploaded yet.</p>
            <Button
              size="small"
              style={{marginRight: 10, marginTop: 5}}
              loading={updating}
              onClick={onShowTemplate}>
              Upload Now
            </Button>
          </Fragment>
        }
        type="info"
        showIcon
      />
    </Fragment>
  )
}

export default UploaderAlert
